var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_753_8634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33332 0H4.08332C5.37198 0 6.41665 1.04467 6.41665 2.33332V4.08332C6.41665 5.37198 5.37198 6.41665 4.08332 6.41665H2.33332C1.04467 6.41668 0 5.37201 0 4.08332V2.33332C0 1.04467 1.04467 0 2.33332 0Z",
    fill: "#B0B3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91682 0H11.6668C12.9555 0 14.0001 1.04467 14.0001 2.33332V4.08332C14.0001 5.37198 12.9555 6.41665 11.6668 6.41665H9.91682C8.62816 6.41665 7.5835 5.37198 7.5835 4.08332V2.33332C7.58347 1.04467 8.62814 0 9.91682 0Z",
    fill: "#B0B3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33332 7.5835H4.08332C5.37198 7.5835 6.41665 8.62816 6.41665 9.91682V11.6668C6.41665 12.9555 5.37198 14.0001 4.08332 14.0001H2.33332C1.04467 14.0002 0 12.9555 0 11.6668V9.91685C0 8.62816 1.04467 7.5835 2.33332 7.5835Z",
    fill: "#B0B3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91682 7.5835H11.6668C12.9555 7.5835 14.0001 8.62816 14.0001 9.91682V11.6668C14.0001 12.9555 12.9555 14.0002 11.6668 14.0002H9.91682C8.62816 14.0002 7.5835 12.9555 7.5835 11.6668V9.91685C7.58347 8.62816 8.62814 7.5835 9.91682 7.5835Z",
    fill: "#B0B3C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_753_8634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#7065E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.88b1faee6aa94984bb06aa38584bec5f.svg";
export { ForwardRef as ReactComponent };